import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  Button,
  Form,
  FormFeedback
} from "reactstrap";
// import caspLogo from "../../assets/images/casp-logo.png"
// import caspLogo from "../../assets/images/casp-main-logo.png"
import stageLogo from '../../assets/images/KVP-logo1.svg';
import seuIcon from "../../assets/images/new-company.svg"
import devLogo from '../../assets/images/PST-logo.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from "../../Components/Common/withRouter";
import { toast } from "react-toastify"
import { validationForToken } from "../../api/casp/user";
import axios from "axios"
import { withTranslation } from "react-i18next";
import LanguageDropdown from "../../Components/Common/LanguageDropdown";

const SetPassword = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { search } = useLocation()
  const navigate = useNavigate()
  const [showpass, setshowpass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  
  useEffect(() => {
    getToken()
  }, [])

  const getToken = async () => {
    try {
      setIsLoading(true);
      const response = await validationForToken({
        token: search.split('&')[0].split('=')[1],
        tokenType: search.split('=')[2]
      })
      if (response.statusCode === 200) {
        // toast.success(response.data.message);
        setIsLoading(false);
      } else {
        toast.error(response.data.error);
        setIsLoading(false);
        navigate('/login')
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
      navigate('/login')
    }
  }

  const passwordPattern = /^(?!.*[\s])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,16}$/;
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validateOnMount: true,
    validationSchema: Yup.object({
      password: Yup.string().required(props.t('Please Enter Your Password')).matches(passwordPattern, props.t("Password should be 8 character long with maximum 16 character of one capital one small one digit and one special case without whitespace")),
      confirmPassword: Yup.string().oneOf([Yup.ref('password')], props.t('Both Passwords must match')).required(props.t('Please Enter Confirm Password'))
    })
  });

  const handlePaswordSet = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/set/password`,
        {
          password: validation.values.password,
          confirmPassword: validation.values.confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${search.split('&')[0].split('=')[1]}`
          },
        }
      );
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        setIsLoading(false);
        navigate('/login')
      } else {
        toast.error(response.data.error);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
    }
  };

  document.title = props.t("Set Password ");
  const matchStageEnv = /\bstage\b/i;
  return (
    <React.Fragment>
       <div style={{ float: "right", marginRight: "20px" }}>
        <LanguageDropdown />
      </div>
      <div
        className="login-bgImg d-flex justify-content-center align-items-center w-100 h-screen"
      >
        <div className="auth-page-content w-100">
          <Container>
            <Row className="justify-content-center mt-3">
              <Col md={8} lg={5}>
                <Card>
                  <CardBody className="p-4">
                    <Row>
                      <Col lg={12}>
                        <div className="text-center text-white-50">
                          <div>
                            <Link to="/" className=" auth-logo">
                              <img src={seuIcon} alt="Logo" className="logo_size" />
                            </Link>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="text-center mt-2">
                      <h5 className="mt-4">{props.t("Please Set Password To Continue")}</h5>
                    </div>
                    <div className="p-2 mt-4">
                      <Form>
                        <div className="mb-3">
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              className="form-control pe-5 py-2"
                              placeholder={props.t("Enter Password")}
                              type={showpass ? "text" : "password"}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password}
                              invalid={
                                validation.touched.password &&
                                  validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                              validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              onClick={() => setshowpass(!showpass)}
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                            >
                              <i
                                className={
                                  showpass == false
                                    ? "ri-eye-fill align-middle"
                                    : "ri-eye-off-fill"
                                }
                              ></i>
                            </button>
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="confirmPassword"
                              value={validation.values.confirmPassword}
                              type={showConfirmPass ? "text" : "password"}
                              className="form-control pe-5 py-2"
                              placeholder={props.t("Enter Confirm Password")}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.confirmPassword &&
                                  validation.errors.confirmPassword
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.confirmPassword &&
                              validation.errors.confirmPassword ? (
                              <FormFeedback type="invalid">
                                {validation.errors.confirmPassword}
                              </FormFeedback>
                            ) : null}
                            <button
                              onClick={() => setShowConfirmPass(!showConfirmPass)}
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                              type="button"
                              id="password-addon"
                            >
                              <i
                                className={
                                  showpass == false
                                    ? "ri-eye-fill align-middle"
                                    : "ri-eye-off-fill"
                                }
                              ></i>
                            </button>
                          </div>
                        </div>

                        <div className="mt-4 text-center">
                          <Button
                            // color="#206DF1"
                            className="btn btn-secondary main-set-password-btn w-100"
                            type="submit"
                            disabled={!validation.isValid || isLoading}
                            onClick={handlePaswordSet}
                          >
                            {props.t("Save")}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(withRouter(SetPassword));
